export default __webpack_public_path__ + "static/media/patients_what.153c1c99.png";